var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2124_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8H57.7778V48H0V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7778 8V48H58.7778V8H56.7778Z",
    fill: "#E5EEFF",
    mask: "url(#path-1-inside-1_2124_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 40L21.0436 19.8257C21.2219 19.1123 21.7789 18.5553 22.4923 18.3769L32 16L31.4009 18.3966C31.2225 19.1099 30.6655 19.667 29.9521 19.8453L24.5795 21.1885C24.2228 21.2776 23.9443 21.5561 23.8551 21.9128L22.2222 28.4444L29.3333 26.6667L28.7342 29.0632C28.5558 29.7766 27.9988 30.3336 27.2854 30.512L21.9128 31.8551C21.5561 31.9443 21.2776 32.2228 21.1885 32.5795L19.8453 37.9521C19.667 38.6655 19.1099 39.2225 18.3966 39.4009L16 40Z",
    fill: "#0A255C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2701 19.2658C31.5567 19.4441 30.9997 20.0012 30.8214 20.7145L29.3333 26.6667L31.7299 26.0675C32.4433 25.8892 33.0003 25.3322 33.1786 24.6188L33.6329 22.8017C33.7221 22.445 34.0006 22.1665 34.3573 22.0774L37.3333 21.3333L35.7004 27.8649C35.6113 28.2216 35.3328 28.5002 34.9761 28.5893L29.6035 29.9325C28.8901 30.1108 28.3331 30.6678 28.1547 31.3812L26.6667 37.3333L29.0632 36.7342C29.7766 36.5558 30.3336 35.9988 30.512 35.2854L30.9662 33.4684C31.0554 33.1117 31.3339 32.8332 31.6906 32.744L37.0632 31.4009C37.7766 31.2225 38.3336 30.6655 38.512 29.9521L41.7778 16.8889L32.2701 19.2658Z",
    fill: "#0A255C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/LogoMenu.8137f18bd86bd23a5cfe1f677c27cb30.svg";
export { ForwardRef as ReactComponent };